(function () {
    /** Set to true to enable console logging for DY Tracker */
    const DY_TRACKER_DEBUG = false;

    function log() {
        if (DY_TRACKER_DEBUG && typeof console !== "undefined" && console.log) {
            console.log.apply(console, arguments);
        }
    }

    function warn() {
        if (DY_TRACKER_DEBUG && typeof console !== "undefined" && console.warn) {
            console.warn.apply(console, arguments);
        }
    }

    log("[DY Tracker] 📦 Script loaded - Initializing DynamicYield tracker...");

    /** @typedef {Window & { BVDY?: any; Shopify?: any; DY?: { API?: (method: string, params: any) => void } }} WindowWithBVDY */
    /** @type {WindowWithBVDY} */
    const win = window;

    if (!win.BVDY) {
        log("[DY Tracker] ⚠️ BVDY not found, creating new instance...");
    }
  
    const STORAGE_PREFIX = "bv_dy_";
    const SESSION_PREFIX = "bv_dy_sess_";
  
    function now() {
      return Date.now();
    }


    function isDYReady() {
      return typeof win.DY?.API === "function";
    }
    
    
    /**
     * @param {() => void} fn
     */
    function safe(fn) {
      try {
        fn();
      } catch (e) {
        // silent
      }
    }
  
    /**
     * @param {string} key
     * @param {string} value
     */
    function setSessionFlag(key, value = "1") {
      safe(() => sessionStorage.setItem(SESSION_PREFIX + key, value));
    }
  
    /**
     * @param {string} key
     */
    function getSessionFlag(key) {
      try {
        return sessionStorage.getItem(SESSION_PREFIX + key);
      } catch (e) {
        return null;
      }
    }
  
    /**
     * @param {string} key
     * @param {string} value
     */
    function setLocalFlag(key, value = "1") {
      safe(() => localStorage.setItem(STORAGE_PREFIX + key, value));
    }
  
    /**
     * @param {string} key
     */
    function getLocalFlag(key) {
      try {
        return localStorage.getItem(STORAGE_PREFIX + key);
      } catch (e) {
        return null;
      }
    }
  
    /**
     * @param {string} key
     */
    function removeLocalFlag(key) {
      safe(() => localStorage.removeItem(STORAGE_PREFIX + key));
    }
  
    /**
     * @param {() => void} cb
     * @param {number} timeoutMs
     */
    function waitForDY(cb, timeoutMs = 8000) {
      const start = now();
      const t = setInterval(() => {
        if (isDYReady()) {
          clearInterval(t);
          cb();
        } else if (now() - start > timeoutMs) {
          clearInterval(t);
        }
      }, 50);
    }
  
    /**
     * @param {string} name
     * @param {Record<string, any>} properties
     */
    function sendEvent(name, properties) {
      safe(() => {
        if (!isDYReady()) {
          warn("[DY Tracker] DynamicYield not ready. Event not sent:", name, properties);
          return;
        }

        const eventPayload = {
          name,
          properties: properties || {},
        };

        log("[DY Tracker] 🎯 Sending event to DynamicYield:", {
          eventName: name,
          payload: eventPayload,
          timestamp: new Date().toISOString(),
        });

        win.DY?.API?.("event", eventPayload);

        log("[DY Tracker] ✅ Event sent successfully:", name);
      });
    }

    // @ts-ignore
    function sendPageContext(eventName, context) {
      
      safe(() => {
        if (!isDYReady()) {
          warn("[DY Tracker] DynamicYield not ready. Event not sent:", name, context);
          return;
        }
        console.log('DY Page context sent', eventName, context);
        win.DY?.API?.(eventName, context);
      });
      log("[DY Tracker] ✅ Page context sent successfully:", context);
    }
    
  
    win.BVDY = {
      waitForDY,
      sendEvent,
      sendPageContext,
      isDYReady,
      setSessionFlag,
      getSessionFlag,
      setLocalFlag,
      getLocalFlag,
      removeLocalFlag,
    };
    
    log("[DY Tracker] ✅ BVDY object created and attached to window");
    log("[DY Tracker] 🔍 Checking DynamicYield availability...");

    if (isDYReady()) {
        log("[DY Tracker] ✅ DynamicYield API is already available!");
    } else {
        log("[DY Tracker] ⏳ DynamicYield API not yet available, will wait for it...");
    }
  })();
  